import { LABELS } from '@/constants/common/message.constants'

import { type TruckSpecificationEntity } from '../..'

/**
 * 荷台側面種別
 */
export type CargoAreaSideType = Exclude<
  TruckSpecificationEntity['cargoAreaSideType'],
  null
>

export const CARGO_AREA_SIDE_TYPE = {
  /** 2段レール */
  DOUBLE_RAIL: 'DOUBLE_RAIL',
  /** シングルレール */
  SINGLE_RAIL: 'SINGLE_RAIL'
} as const satisfies Record<CargoAreaSideType, CargoAreaSideType>

export const CARGO_AREA_SIDE_TYPE_LABEL = {
  [CARGO_AREA_SIDE_TYPE.DOUBLE_RAIL]: LABELS.DOUBLE_RAIL,
  [CARGO_AREA_SIDE_TYPE.SINGLE_RAIL]: LABELS.SINGLE_RAIL
} as const satisfies Record<CargoAreaSideType, string>
